<template lang="pug">
    div
        q_text(
        question="First Name"
        slug="q_parent_first_name"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="Last Name"
        slug="q_parent_last_name"
        :multi_field_num="multi_field_num"
        )
        q_static_ddl(
        question="Suffix"
        slug="q_parent_suffix"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="Email"
        slug="q_parent_email"
        :multi_field_num="multi_field_num"
        )
        q_static_ddl(
        question="Address Same as Applicant"
        slug="q_parent_address_same_applicant"
        :multi_field_num="multi_field_num"
        )
        q_searchable_ddl(
        question="Country",
        slug='q_parent_home_country'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='Street'
        slug='q_parent_home_street'
        placeholder='Street'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='City'
        slug='q_parent_home_city'
        placeholder='City'
        :multi_field_num="multi_field_num"
        )
        q_searchable_ddl(
        question="State",
        slug='q_parent_home_state'
        :multi_field_num="multi_field_num"
        )
        q_searchable_ddl(
        question="Province",
        slug='q_parent_home_province'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='Zip'
        slug='q_parent_home_zip'
        placeholder='Zip'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='Postal'
        slug='q_parent_home_postal'
        placeholder='Postal'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='Preferred Phone'
        slug='q_parent_preferred_phone'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='Occupation'
        slug='q_parent_occupation'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='Employer'
        slug='q_parent_employer'
        :multi_field_num="multi_field_num"
        )
        q_static_ddl(
        question="Attend College"
        slug="q_parent_attend_college"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="College 1"
        slug="q_parent_college_1"
        :multi_field_num="multi_field_num"
        )
        q_static_ddl(
        question="Highest Degree Earned"
        slug="q_parent_degree_1"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="College 2"
        slug="q_parent_college_2"
        :multi_field_num="multi_field_num"
        )
        q_static_ddl(
        question="Highest Degree Earned"
        slug="q_parent_degree_2"
        :multi_field_num="multi_field_num"
        )
</template>
<script>
import MultiField from "../../baseQuestion/multiField";
import q_text from "../../baseQuestion/text";
import q_static_ddl from "../../baseQuestion/staticDDL";
import q_searchable_ddl from "../../baseQuestion/searchableDDL";

export default {
	extends: MultiField,
	props: ["multi_field_num"],
	components: {
		q_text,
		q_static_ddl,
		q_searchable_ddl
	},
	methods: {
		process_delete() {
			this.$emit("trigger-delete", this.multi_field_num);
		}
	}
};
</script>
